import axios from "axios";

export default {
    state: {
        items: [],
        filteredItems: [],
        itemsPerPage: 1,
        currentPage: 1,
        init: false,
    },

    getters: {
        // returns the number of filtered items
        filteredItemsCount: (state) => {
            return state.filteredItems.length;
        },
        // returns items depending on current page and the amount of items per page
        pagedItems: (state) => {
            return state.filteredItems.filter(
                (project, index) =>
                    index >= (state.currentPage - 1) * state.itemsPerPage &&
                    index <
                        (state.currentPage - 1) * state.itemsPerPage +
                            state.itemsPerPage
            );
        },
        // returns the number of pages depending on items per page
        pages: (state, getters) => {
            return Math.ceil(getters.filteredItemsCount / state.itemsPerPage);
        },
        // return current page
        currentPage: (state) => {
            return state.currentPage;
        },
        // calculate items already shown while paginating
        pagedItemsShown: (state, getters) => {
            if (state.currentPage < getters.pages) {
                return state.currentPage * getters.pagedItems.length;
            } else {
                return (
                    (state.currentPage - 1) * state.itemsPerPage +
                    getters.pagedItems.length
                );
            }
        },
        isInit: (state) => {
            return state.init;
        },
        filteredItems: (state) => {
            return state.filteredItems;
        },
        singleFilterScopeWorlwide: (state) => {
            return state.items.filter((item) => {
                if (item.scope[0].id.toString().indexOf("3") !== -1) {
                    return true;
                }
            }).length;
        },
        itemByID: (state) => (id) => {
            return state.filteredItems.find((item) => item.id === id);
        },
    },

    mutations: {
        // reset items
        RESET_ITEMS(state) {
            state.filteredItems = state.items;
        },
        // change value of allowed items per page
        SET_ITEMS_PER_PAGE(state, n) {
            state.itemsPerPage = n;
        },
        // update items after loading, filtering etc
        SET_ITEMS(state, n) {
            state.filteredItems = n;
        },
        // pagination - update current page
        SET_CURRENT_PAGE(state, n) {
            state.currentPage = n;
        },
        // update pagination (previous page)
        SET_PREV_PAGE(state, n) {
            state.currentPage = n;
        },
        // update pagination (next page)
        SET_NEXT_PAGE(state, n) {
            state.currentPage = n;
        },
        INIT_PROJECTS(state, n) {
            state.items = n;
            state.filteredItems = n;
            state.init = true;
        },
    },

    actions: {
        resetItems({ commit }) {
            commit("RESET_ITEMS");
        },
        // change value of allowed items per page
        updateItemsPerPage({ commit }, payload) {
            commit("SET_ITEMS_PER_PAGE", payload);
        },
        // update items after loading, filtering etc
        updateItems({ commit }, payload) {
            commit("SET_CURRENT_PAGE", 1);
            commit("SET_ITEMS", payload);
        },
        // pagination - update current page
        updatePage({ commit }, payload) {
            commit("SET_CURRENT_PAGE", payload);
        },
        // update pagination (previous page)
        prevPage({ commit, state }) {
            let currentPage = state.currentPage;
            if (currentPage > 1) {
                currentPage--;
            }
            commit("SET_PREV_PAGE", currentPage);
        },
        // update pagination (next page)
        nextPage({ commit, state }) {
            let currentPage = state.currentPage;
            if (
                currentPage <=
                Math.ceil(state.filteredItems.length / state.itemsPerPage) - 1
            ) {
                currentPage++;
            }
            commit("SET_NEXT_PAGE", currentPage);
        },
        // initially get items from rest api
        async initProjects({ commit, getters, dispatch }) {
            try {
                const response = await axios.get(
                    getters.apiConfig.PROJECTS_URL
                );
                dispatch(
                    "updateItemsPerPage",
                    getters.listConfig.ITEMS_PER_PAGE
                );
                commit("INIT_PROJECTS", response.data.data);
            } catch (err) {
                // Handle Error Here
                console.error(err);
            }
        },
    },
};
